import { Button } from '../../components/Button';
import { Modal } from '../../components/Modal';
import { CloseIcon } from '../../icons/CloseIcon';
import {
  ActionBar,
  Body,
  CloseButton,
  CloseIconFrame,
  Content,
  Heading,
  Image,
  ImageSlot,
  ValidFor,
  Wrapper,
} from './AnnouncementDialog.styles';
import type { AnnouncementDialogCta, AnnouncementDialogProps } from './AnnouncementDialog.types';

function CtaButton({ cta }: { cta: AnnouncementDialogCta }) {
  if (cta.href !== undefined) {
    return (
      <Button variant="primary" size="large" fullWidth href={cta.href} onClick={cta.onClick}>
        {cta.label}
      </Button>
    );
  }

  return (
    <Button variant="primary" size="large" fullWidth onClick={cta.onClick}>
      {cta.label}
    </Button>
  );
}

export function AnnouncementDialog({
  open,
  onClose,
  heading,
  body,
  imageUrl,
  validFor,
  cta,
  closeLabel = 'Close',
}: AnnouncementDialogProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      ariaLabel={heading}
      aboveMobileNav
      size="lg"
      disableBodyPadding
      footer={
        cta && (
          <ActionBar>
            <CtaButton cta={cta} />
          </ActionBar>
        )
      }
    >
      <Wrapper data-has-cta={cta ? 'true' : 'false'}>
        <ImageSlot data-has-image={imageUrl ? 'true' : 'false'}>
          {imageUrl && <Image src={imageUrl} alt="" />}
          <CloseButton type="button" onClick={onClose} aria-label={closeLabel}>
            <CloseIconFrame>
              <CloseIcon size={10} />
            </CloseIconFrame>
          </CloseButton>
        </ImageSlot>
        <Content>
          <Heading>{heading}</Heading>
          {validFor && <ValidFor>{validFor}</ValidFor>}
          <Body text={body} />
        </Content>
      </Wrapper>
    </Modal>
  );
}
